module.exports = __webpack_public_path__ + "static/media/Slide_3.e3642693.png";